export default __webpack_public_path__ + "static/media/blog-img-2.37decbc7.webp";